import { WEBSITE_TRAFFIC_BY_SOURCE } from '@mm/api-routes';
import {
  SEMRushWebsiteCompetitorsModel,
  SEMRushWebsiteSummaryModel,
  SEMRushWebsiteTopLandingsModel,
  SEMRushWebsiteTrafficByMonthModel,
  SEMRushWebsiteTrafficModel,
} from '../model/SEMRushWebsiteTrafficModel';
import Controller from './Controller';

export type WebsiteTrafficSources =
  | 'totals'
  | 'per_month'
  | 'summary'
  | 'competitors'
  | 'top_pages';

export default class SEMRushWebsiteTrafficController extends Controller {
  static async getTotalsByDomain(
    domain: string,
    ipAdress?: string,
    countryCode?: string,
  ): Promise<SEMRushWebsiteTrafficModel> {
    const baseUrl = `${WEBSITE_TRAFFIC_BY_SOURCE('totals')}?d=${domain}`;
    const baseUrlwithIP = ipAdress ? `${baseUrl}&ip=${ipAdress}` : baseUrl;
    const baseUrlFull = countryCode
      ? `${baseUrlwithIP}&country_code=${countryCode}`
      : baseUrlwithIP;
    return super.get(baseUrlFull);
  }

  static async getMonthlyByDomain(
    domain: string,
    ipAdress?: string,
  ): Promise<SEMRushWebsiteTrafficByMonthModel> {
    return super.get(
      `${WEBSITE_TRAFFIC_BY_SOURCE('per_month')}?d=${domain}&ip=${ipAdress}`,
    );
  }

  static async getTopPages(
    domain: string,
    displayDate?: string,
  ): Promise<SEMRushWebsiteTopLandingsModel> {
    const date = displayDate ? `&display_date=${displayDate}` : '';
    return super.get(
      `${WEBSITE_TRAFFIC_BY_SOURCE('top_pages')}?d=${domain}${date}`,
    );
  }

  static async getCompetitors(
    domain: string,
  ): Promise<SEMRushWebsiteCompetitorsModel> {
    return super.get(`${WEBSITE_TRAFFIC_BY_SOURCE('competitors')}?d=${domain}`);
  }

  static async getSummary(domain: string): Promise<SEMRushWebsiteSummaryModel> {
    return super.get(`${WEBSITE_TRAFFIC_BY_SOURCE('summary')}?d=${domain}`);
  }
}
